import { defineStore } from 'pinia'
import _ from 'lodash'

export const useGlobalStore = defineStore('global', {
	state: () => {
		return {
			pages: [],
			mobile: false,
			cart: false,
			screenWidth: typeof window !== 'undefined' ? window.innerWidth : 1920,
			breakpoint: null,
			modal: {
				name: null,
				payload: null,
			},
			clients: [],
			testimonials: [],
			awardPlatforms: [],
			relics: [],
			colorOfHonor: {},
			policyPages: [],
			navigation: [
				{
					title: 'Home',
					to: { name: 'index' },
				},
				{
					title: 'Services',
					to: { name: 'services' },
				},
				{
					title: 'Work',
					to: { name: 'work' },
				},
				{
					title: 'About',
					to: { name: 'about' },
				},
				{
					title: 'News',
					to: { name: 'news' },
				},
				{
					title: 'Lost Art',
					to: { name: 'lost-art' },
				},
			],
		}
	},
	getters: {
		//
	},
	actions: {
		toggleMobile(delta) {
			delta != null ? (this.mobile = delta) : (this.mobile = !this.mobile)
		},
		setScreenWidth(width) {
			this.screenWidth = width
		},
		setBreakpoint(breakpoint) {
			this.breakpoint = breakpoint
		},
		setup() {
			this.getPages()
			this.getClients()
			this.getTestimonials()
			this.getAwardPlatforms()
			this.getRelics()
			this.getColorOfHonor()
			this.getPolicyPages()
		},
		getPages() {
			return axios
				.get('/api/pages')
				.then((pages) => {
					this.pages = pages.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getClients() {
			return axios
				.get('/api/clients')
				.then((clients) => {
					this.clients = clients.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getTestimonials() {
			return axios
				.get('/api/testimonials')
				.then((testimonials) => {
					this.testimonials = testimonials.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getAwardPlatforms() {
			return axios
				.get('/api/award-platforms')
				.then((awardPlatforms) => {
					this.awardPlatforms = awardPlatforms.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getRelics() {
			return axios
				.get('/api/relics')
				.then((relics) => {
					this.relics = relics.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getColorOfHonor() {
			return axios
				.get('/api/color-of-honor')
				.then((colorOfHonor) => {
					this.colorOfHonor = colorOfHonor.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getPolicyPages() {
			return axios
				.get('/api/policy')
				.then((policyPages) => {
					this.policyPages = policyPages.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		openModal(modal) {
			this.modal = {
				name: modal,
				payload: null,
			}
			document.body.classList.add('overflow-hidden')
		},
		setModal(modal) {
			this.modal = {
				name: modal[0],
				payload: modal[1],
			}
		},
		closeModal() {
			this.modal = {
				name: null,
				payload: null,
			}
			document.body.classList.remove('overflow-hidden')
		},
	},
})
